import * as React from 'react';
import { addProtocolIfAbsent, isURL } from 'common/util/url';
export const InvisibleSubmit = () => {
  return <input
  //hack to allow form submits via enter button
  type='submit' tabIndex={-1} style={{
    position: "absolute",
    left: "-9999px",
    width: "1px",
    height: "1px"
  }} data-sentry-component="InvisibleSubmit" data-sentry-source-file="mixins-react.tsx" />;
};
export function renderSegmentLabel(label: string) {
  if (isURL(label)) {
    return <a href={addProtocolIfAbsent(label)} target={"_blank"} rel={"noopener noreferrer"}>
        {label}
      </a>;
  }
  return label;
}